/**
 * tutorScoreFormatter — comment le score du masteur s'écrit (l'ancienne `TutorScoreCardM.js`).
 *
 * Un taux arrive de 0 à 1 ; il s'écrit en pour cent arrondi, l'espace insécable avant le signe,
 * et « - » tant qu'il n'y a pas de mesure (la carte d'aujourd'hui l'écrit ainsi).
 */
import { type UITutorScorePeriod } from "../types/tutorCoquilleAccueil"

const NBSP = " "

/** « 87 % », « - » sans mesure. */
export function percentLabel(ratio: number | null | undefined): string {
    if (ratio == null || Number.isNaN(ratio)) return "-"
    return `${Math.round(ratio * 100)}${NBSP}%`
}

/** Le rang s'affiche une fois le seuil d'activité atteint, ou en cumulé (la règle de l'ancienne carte). */
export function showsRank(period: UITutorScorePeriod, threshold: number, cumulative: boolean): boolean {
    return period.rank != null && (cumulative || period.livesCount >= threshold)
}

/** L'assiduité sous la moitié, avec au moins un live : l'axe passe en alerte. */
export function isPunctualityLow(period: UITutorScorePeriod): boolean {
    const punctuality = period.axes.find((axis) => axis.key === "punctuality")?.value
    return punctuality != null && punctuality < 0.5 && period.livesCount > 0
}
